var t={}.constructor;function n(r){return r!=null&&r.constructor===t}

export { n as default };
//# sourceMappingURL=contact-channels153.js.map
